import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import StepCopyContainer from './StepCopyContainer';
import StepContainer from './StepContainer';
import StepThreeSignature from './StepThreeSignature';

const StepThree = () => (
    <StepContainer className="buying-online-steps--step-3">
        <StepCopyContainer
            heading="3. Make it official"
            subHeading={
                <span>
                    Once your order is all set, we schedule your delivery or express pickup<sup>&dagger;</sup> so you
                    can meet the car.
                </span>
            }
            forceGutterBottom
        />
        <Box
            sx={{
                height: { xs: '27.5rem', sm: '25.5rem', md: '32.75rem', lg: '35.5rem' },
                minWidth: 0,
                mb: { md: -4, lg: -5.5 },
                flex: { lg: '1 0 0' },
            }}
        >
            <img
                src="/home/images/buying-online/steps/buyonline-esign.png"
                alt="A digital signature written on phone in landscape orientation"
                height="100%"
            />
            <Paper
                className="buying-online-steps--signature-container"
                elevation={5}
                sx={{
                    borderRadius: { xs: 1.5, sm: 2 },
                    mt: { xs: -45, sm: -46, md: -55, lg: -58.5 },
                    ml: { xs: 3, sm: 15, md: 25.5, lg: 30 },
                    padding: { xs: 3, sm: 2 },
                    width: { xs: '17.4375rem', sm: '22.375rem' },
                    height: { xs: '8.5626rem', sm: '11.8125rem' },
                }}
            >
                <Divider
                    className="buying-online-steps--signature-underline"
                    sx={{
                        transform: {
                            xs: 'translateY(5rem)',
                            sm: 'translateY(8rem)',
                            md: 'translateY(7.75rem)',
                        },
                    }}
                />
                <Box
                    className="buying-online-steps--signature-sign-flag"
                    sx={({ palette }) => ({
                        width: { xs: '4rem', sm: '5.5rem' },
                        height: { xs: '2rem', sm: '2.75rem' },
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: palette.primary.faint,
                        transform: {
                            xs: 'translate(-1rem, 1rem) rotate(-90deg)',
                            sm: 'translate(-1.375rem, 2.375rem) rotate(-90deg)',
                            md: 'translate(-1.375rem, 2.125rem) rotate(-90deg)',
                        },
                        '&:before': {
                            position: 'absolute',
                            content: '""',
                            borderRight: {
                                xs: `1rem solid ${palette.primary.faint}`,
                                sm: `1.5rem solid ${palette.primary.faint}`,
                            },
                            borderTop: {
                                xs: '1rem solid transparent',
                                sm: '1.375rem solid transparent',
                            },
                            borderLeft: {
                                xs: '1rem solid transparent',
                                sm: '.5rem solid transparent',
                            },
                            borderBottom: {
                                xs: '1rem solid transparent',
                                sm: '1.375rem solid transparent',
                            },
                            top: 0,
                            left: '-2rem',
                        },
                    })}
                >
                    <Typography className="buying-online-steps--signature-sign-label" color="primary" variant="h6">
                        Sign
                    </Typography>
                </Box>
                <Box
                    className="buying-online-steps--signature"
                    sx={{
                        transform: {
                            xs: 'translate(2.75rem, -1.75rem)',
                            sm: 'translate(4rem, -1.25rem)',
                            md: 'translate(4rem, -1.5rem)',
                            lg: 'translate(4.25rem, -1.5rem)',
                        },
                        '& > svg': {
                            width: {
                                sm: '14.375rem',
                            },
                            height: {
                                sm: '7.4375rem',
                            },
                        },
                    }}
                >
                    <StepThreeSignature />
                </Box>
            </Paper>
        </Box>
    </StepContainer>
);

export default StepThree;
